import { emptyFilters } from "../constants/filterDefaults";

export function countActiveFilters(filters) {
    if (!filters) return 0;
    let count = 0;

    for (const key of Object.keys(emptyFilters)) {
        const val = filters[key];
        if (Array.isArray(val)) {
            count += val.length;
        } else if (val != null && val !== "" && val !== false) {
            count += 1;
        }
    }

    return count;
}
